import React from "react";
import "./AiAssistCard.scss";

interface ChildProps {
    message: string;
    currentCardSetter: () => void;
}

const AiAssistCard: React.FC<ChildProps> = ({ currentCardSetter, message }) => {
    return (
        <div className="card-layout" onClick={currentCardSetter}>
            {message}
        </div>
    );
};

export default AiAssistCard;
